var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.account)?_c('router-link',{attrs:{"to":{name: 'Account', params: {id: _vm.account.id}}}},[_vm._v(" "+_vm._s(_vm.account.name)+" ")]):_c('span',[_vm._v(_vm._s(_vm.$t('common.misc.NA')))])
}
var staticRenderFns = []

export { render, staticRenderFns }